import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import { MembershipService } from '@app/services/membership.service';
import { SnackbarService } from '@app/services/shared/snackbar.service';
import { Subscription } from 'rxjs';
import moment from 'moment';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
@Component({
  selector: 'app-terminatemembership',
  templateUrl: './terminatemembership.component.html',
  styleUrls: ['./terminatemembership.component.css']
})
export class TerminatemembershipComponent implements OnChanges, OnDestroy, OnInit {
  @Input() memberid: number;
  @Input() givenname: string;
  @Input() familyname: string;
  @Input() primarylodgeformember: number;
  @Output() closeTerminate: EventEmitter<any> = new EventEmitter();
 terminatemembershipform;
  

  subscriptions: Subscription[] = [];
  minmaxyear = { minYear: '1920', maxYear: '2030' };
  autoCorrectedDatePipe = createAutoCorrectedDatePipe('yyyy-mm-dd', this.minmaxyear);
  public maskdatum = [/[129]/, /[?09]/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private membershipService: MembershipService,
    private snackbarService: SnackbarService,
    private confirmationService: ConfirmationService) { }

    ngOnInit(): void {
      this.terminatemembershipform = this.fb.group({
        memberId: ['', ''],
        institutionId: ['', ''],
        fromDate: ['', Validators.required],
        gott: ['', Validators.required],
        action: ['update', '']
      });
  }
  
  ngOnChanges(_: SimpleChanges) {
    if(_ && this.terminatemembershipform) {
      this.terminatemembershipform.get('memberId').setValue(this.memberid.toString());
      this.terminatemembershipform.get('institutionId').setValue(this.primarylodgeformember.toString());
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }

  close() {
    this.closeTerminate.emit();
  }

  save() {
    const date = moment(this.terminatemembershipform.get('fromDate').value).add(3, 'h').format('YYYY-MM-DD HH:mm')
    const data = {
      memberId: this.memberid,
      institutionId: this.primarylodgeformember,
      causeId: this.terminatemembershipform.get('gott').value,
      date: date
    };
    this.subscriptions.push(this.membershipService.EndMemberMembership(data).subscribe(response => {
      this.snackbarService.openSnackBar(response, null);
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigateByUrl('/memberform/id/' + this.memberid);
      this.terminatemembershipform.reset();
      this.close();
    }));
  }

  confirmDialog(): void {
      this.confirmationService.confirm({
      header: 'Bekräftelse',
      message: 'Vill du avsluta medlemskapet?',
      acceptLabel: 'Ja',
      rejectLabel: 'Nej',
      accept: () => {
        this.save();
      },
      reject: () => {
      }
    });
  }
}
